import ttiPolyfill from 'tti-polyfill'

export const setup = () => `
// Required for ttfp & ttfcp
if ('PerformanceObserver' in window) {
  const observer = new PerformanceObserver(list => {
    for (const entry of list.getEntries()) {
      if (['first-paint', 'first-contentful-paint'].includes(entry.name)) {
        const key = entry.name === 'first-paint' ? '__ttfp' : '__ttfcp'
        window[key] = entry.startTime + entry.duration
      }
    }
  })

  observer.observe({ entryTypes: ['resource', 'paint'] })
}

// Required for tti
if ('PerformanceLongTaskTiming' in window) {
  const ttiObserver = (window.__tti = { e: [] })

  ttiObserver.o = new PerformanceObserver(list => {
    ttiObserver.e = ttiObserver.e.concat(list.getEntries())
  })

  ttiObserver.o.observe({ entryTypes: ['longtask'] })
}
`

export const measure = async () => {
  if (!window || !('addEventListener' in window)) return Promise.resolve({})

  return new Promise(resolve => {
    window.addEventListener('load', () => {
      setTimeout(async () => {
        const performance =
          window.performance ||
          (window as any).webkitPerformance ||
          (window as any).msPerformance ||
          (window as any).mozPerformance

        if (!performance) return Promise.resolve({})

        // Replaces old PerformanceTiming but not supported by Safari
        const performanceNavigationTiming =
          performance.getEntriesByType &&
          (performance.getEntriesByType(
            'navigation'
          )[0] as PerformanceNavigationTiming)

        // It's deprecated api but still supported by all major browsers
        const deprecatedPerformanceTiming = performance.timing

        const t = performanceNavigationTiming || deprecatedPerformanceTiming

        if (!t) return Promise.resolve({})

        const ttci = await ttiPolyfill.getFirstConsistentlyInteractive()
        const { __ttfp: ttfp = null, __ttfcp: ttfcp = null } = window as any
        const domContentLoaded = t.domContentLoadedEventEnd - t.fetchStart
        const pageLoad = t.loadEventEnd - t.fetchStart
        const dnsLookupTime = t.domainLookupEnd - t.domainLookupStart
        const redirectTime = t.redirectEnd - t.redirectStart
        const tcpConnectionTime = t.connectEnd - t.connectStart
        const ttfb = t.responseStart - t.requestStart
        const responseProcessingTime = t.responseEnd - t.responseStart

        const metrics = {
          ttci,
          ttfp,
          ttfcp,
          domContentLoaded,
          pageLoad,
          dnsLookupTime,
          redirectTime,
          tcpConnectionTime,
          ttfb,
          responseProcessingTime
        }

        return resolve(metrics)
      }, 0)
    })
  })
}
